import styled, { css } from 'styled-components';
import { space } from 'styled-system';
export var Container = styled.div.withConfig({
  displayName: "NumericFormatterstyles__Container",
  componentId: "keen-widget-settings__sc-82c16t-0"
})(["&&&{display:flex;flex-direction:column;row-gap:10px;max-width:500px;}"]);
export var Row = styled.div.withConfig({
  displayName: "NumericFormatterstyles__Row",
  componentId: "keen-widget-settings__sc-82c16t-1"
})(["&&&{display:flex;align-items:center;justify-content:space-between;column-gap:10px;", ";", ";}"], space, function (_ref) {
  var isDisabled = _ref.isDisabled;
  return isDisabled && css(["opacity:0.5;pointer-events:none;"]);
});
export var MultiControl = styled.div.withConfig({
  displayName: "NumericFormatterstyles__MultiControl",
  componentId: "keen-widget-settings__sc-82c16t-2"
})(["&&&{position:relative;display:grid;grid-template-columns:repeat(2,1fr);width:100%;max-width:310px;", ";}"], function (_ref2) {
  var isDisabled = _ref2.isDisabled;
  return isDisabled && css(["opacity:0.5;pointer-events:none;"]);
});
export var ControlContainer = styled.div.withConfig({
  displayName: "NumericFormatterstyles__ControlContainer",
  componentId: "keen-widget-settings__sc-82c16t-3"
})(["&&&{width:100%;max-width:310px;}"]);
export var StyledLabel = styled.label.withConfig({
  displayName: "NumericFormatterstyles__StyledLabel",
  componentId: "keen-widget-settings__sc-82c16t-4"
})(["&&&{cursor:pointer;margin:0;padding:0;line-height:1;}"]);
export var LabelText = styled.span.withConfig({
  displayName: "NumericFormatterstyles__LabelText",
  componentId: "keen-widget-settings__sc-82c16t-5"
})(["&&&{margin-left:5px;display:inline-block;}"]);